/**
 * 홈 화면 우측 열의 "AI 진단" 안내 카드.
 *
 * StudentHome 이 TodayProblem 옆에 SolvedProblems 와 세로로 나란히 배치한다.
 * 로그인한 모든 계정을 체험용으로 간주하는 현재 정책 때문에, 클릭해도 실제 AI 진단
 * 화면으로 이동하지 않고 useTrialBlock 이 접근 제한 모달을 띄운다.
 */
import React from "react";
import CircleArrowRight from "../icons/CircleArrowRight";
import BarChart from "../icons/home/BarChart";
import { useTrialBlock } from "@/hooks/useTrialBlock";

/** AI 진단 카드. 클릭하면 체험용 계정 접근 제한 모달을 띄운다. */
function AICard() {
  // 체험용 계정: AI 진단 진입 대신 접근 제한 모달
  const openTrialBlock = useTrialBlock();

  return (
    <div
      onClick={() => openTrialBlock("AI 진단")}
      className="border border-line h-1/2 problem-card flex justify-between cursor-pointer"
    >
      <div className="flex flex-col gap-y-[10px]">
        <div className="text-18 font-extrabold text-heading font-heading">AI 진단</div>
        <div className="text-16 text-body font-normal">
          <div>나의 학습 역량을</div>
          <div>진단해요</div>
        </div>
        <CircleArrowRight />
      </div>
      <div className="flex items-end">
        <BarChart />
      </div>
    </div>
  );
}

export default AICard;
